// extracted by mini-css-extract-plugin
export default {"chatBar_container":"chatBar_chatBar_container__pP1f8"};